import {useNavigate, useParams} from "react-router-dom";
import ProgressTable from "../components/progress-table";
import {useContext, useEffect} from "react";
import {TokenContext} from "../../App";

export default function Progress({challenges}) {
    const {id} = useParams();
    const challenge = challenges.find((challenge) => challenge.id === Number.parseInt(id));
    const [token] = useContext(TokenContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/admin/login");
        }
    }, []);

    return (
        <div className="flex flex-col gap-10 mt-5 justify-self-center justify-center text-center">
            <ProgressTable challenge={challenge}/>
        </div>
    );
}